import * as React from 'react';
import * as styles from './styles.css';

import { Spinner, UIText1, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

interface IMarketTrendsSpinnerProps {
  isDesktop: boolean;
}

export const MarketTrendsSpinner: React.FC<IMarketTrendsSpinnerProps> = ({ isDesktop }) => {
  return (
    <>
      <div data-testid="MarketTrendsSpinner_title" className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading1} ElseComponent={UIHeading2}>
          Тренды на рынке недвижимости
        </ConditionalWrapper>
      </div>
      <div className={styles['sub-title']}>
        <UIText1>Делаем выводы на основе объектов в этом и соседних домах</UIText1>
      </div>
      <div className={styles['spinner']}>
        <Spinner />
      </div>
    </>
  );
};

MarketTrendsSpinner.displayName = 'MarketTrendsSpinner';
